import * as React from "react";
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';
import ListItemText, { ListItemTextProps } from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Link, LinkProps } from 'react-router-dom';
import { WithStyles, withStyles, createStyles } from './styles';



const styles = () => createStyles({
    icon: {
        marginRight: 0
    },
    gutters: {

    }
});

export type ListItemLinkProps = {
    directLink?: boolean;
    blankTarget?: boolean;
    icon?: any;
} & ListItemProps & LinkProps & ListItemTextProps;

type Props = ListItemLinkProps & WithStyles<typeof styles>;

class ListItemLink extends React.Component<Props>{

    render() {
        const { icon, classes, button, inset, directLink, ...others } = this.props;
        const renderLink = (itemProps: ListItemProps) => {
            const { to, blankTarget } = this.props;
            const target = blankTarget === false ? '_self' : '_blank';
            return directLink ? <a href={to.toString()} {...itemProps} target={target} /> : <Link to={to} {...itemProps} />;
        }
        return <ListItem {...others} classes={{ gutters: classes.gutters }} button={button} component={renderLink} >
            {inset && icon && <ListItemIcon classes={{ root: classes.icon }}>{icon}</ListItemIcon>}
            <ListItemText {...others} inset={inset} />
        </ListItem>
    }
}

export default withStyles(styles)(ListItemLink);